import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { PrefCenterComponent } from './components/pref-center/pref-center.component';

const routes: Routes = [
  { path: '', component: HomeComponent, data: {headerTitle: 'Contract Compliance'}},
  //{ path: '', redirectTo: '/preferences/', pathMatch: 'full'},
  { path: 'preferences', component: PrefCenterComponent },
  { path: 'preferences/:id', component: PrefCenterComponent },
  //{ path: '**',  component: PrefCenterComponent, data: {headerTitle: 'Preference Center'}}

  { path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
